export function isAllIdsSelected(
  selectedIds: number[],
  allIds: number[],
): boolean {
  return selectedIds.length === 0 || selectedIds.length === allIds.length;
}

export function getEffectiveSelectedIds(
  selectedIds: number[],
  allIds: number[],
): Set<number> {
  if (selectedIds.length === 0) {
    return new Set(allIds);
  }

  return new Set(selectedIds);
}

export function toggleIdInSelection(
  selectedIds: number[],
  allIds: number[],
  toggledId: number,
): number[] {
  const baseIds = selectedIds.length === 0 ? [...allIds] : [...selectedIds];
  const next = baseIds.includes(toggledId)
    ? baseIds.filter((id) => id !== toggledId)
    : [...baseIds, toggledId];

  if (next.length === 0 || next.length === allIds.length) {
    return [];
  }

  return next;
}

export function sameIdSets(left: number[], right: number[]): boolean {
  if (left.length !== right.length) {
    return false;
  }

  const rightIds = new Set(right);
  return left.every((id) => rightIds.has(id));
}
